import { combineReducers } from 'redux';
import megaMenu from './mega-menu';
import mobileMenu from './mobile-menu';
import accountMenu from './account-menu';

export default combineReducers({
  megaMenu,
  mobileMenu,
  accountMenu,
});
